import { safe } from 'framework/api';
import { DifferenceRequestData, DifferenceResponseType } from './useDifferenceByLinks';

const loadDiffSafe = async (
  getToken: (path: string) => Promise<string>,
  getDiff: (requestData: DifferenceRequestData) => Promise<DifferenceResponseType>,
  oldPath: Nullable<string>,
  newPath: Nullable<string>,
) => {
  if (!oldPath || !newPath) {
    return { diff: null, hasError: false };
  }

  const [oldUrl, oldErr] = await safe<string>(() => getToken(oldPath));
  const [newUrl, newErr] = await safe<string>(() => getToken(newPath));

  if (oldErr || newErr || !oldUrl || !newUrl) {
    return { diff: null, hasError: true };
  }

  const [diff, diffErr] = await safe<DifferenceResponseType>(() => getDiff({ oldUrl, newUrl }));

  return { diff, hasError: diffErr };
};

export default loadDiffSafe;
